module.exports = __webpack_public_path__ + "static/media/carlos.31867cf8.PNG";